var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-header"},[_c('GFMP',{attrs:{"wrapper-styles":{ width: '90%' },"styles":{ ..._vm.fmpStyles.rounded }}})],1),_vm._l((3),function(i){return _c('ReviewCardLoader',{key:i})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }